import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  signupNewsletter: {
    id: 'portal.components.newsletter.signup.title',
    defaultMessage: 'Sign up to our newsletter',
    description: 'Newsletter signup title',
  },
  enterEmail: {
    id: 'portal.components.newsletter.enterEmail.placeholder',
    defaultMessage: 'Enter email address',
    description: 'Newsletter email input placeholder',
  },
});

export default messages;
